import { Avatar, Grid, Link, Tooltip, useMediaQuery } from "@material-ui/core";
import { ReactComponent as ApplicationIcon } from 'assets/img/ui/application.svg';
import { ReactComponent as ArtIcon } from 'assets/img/ui/art.svg';
import { ReactComponent as DesignIcon } from 'assets/img/ui/design.svg';
import { ReactComponent as GameIcon } from 'assets/img/ui/game.svg';
import { ReactComponent as MachineLearningIcon } from 'assets/img/ui/machine-learning.svg';
import { ReactComponent as WebIcon } from 'assets/img/ui/web.svg';
import React, { useEffect, useState } from 'react';
import { authorDict, typeClassificationConfig } from '../../pages/Projects/projectConfig';
import './ProjectCardTooltip.scss';


export const ProjectCardTooltip = ({ children, open, title, desc, types, exp, authors }) => {

    const isMobile = useMediaQuery('(max-width:600px)');

    const ProjectCardTooltipContentWrapper = () => {
        return (
            <div>
                <TooltipTitle text={title} />
                <TooltipParagraph node={desc} />
                <TooltipSubtitle text="Type" />
                <TooltipParagraph node={<TooltipTypes types={types} />} />
                {
                    exp &&
                    <>
                        <TooltipSubtitle text="Experience" />
                        <TooltipExp exp={exp} />
                    </>
                }
                <TooltipSubtitle text="Authors" />
                <TooltipAuthors authors={authors} />
            </div>
        )
    }

    const TooltipTitle = ({ text }) => {
        return (
            <div className="project-card-tooltip-title">
                <div>{text}</div>
            </div>
        )
    }

    const TooltipSubtitle = ({ text }) => {
        return (
            <div className="project-card-tooltip-subtitle">
                <div>{text}</div>
            </div>
        )
    }

    const TooltipParagraph = ({ node }) => {
        return (
            <div className="project-card-tooltip-p">
                {node}
            </div>
        )
    }

    const TooltipTypes = ({ types }) => {
        return (
            <div className="project-card-tooltip-types">
                <ArtIcon className={`tooltip-type-icon ${types.includes("Art") ? "art-icon-active" : ""}`} />
                <MachineLearningIcon className={`tooltip-type-icon ${types.includes("Machine Learning") ? "machine-learning-icon-active" : ""}`} />
                <GameIcon className={`tooltip-type-icon ${types.includes("Game") ? "game-icon-active" : ""}`} />
                <WebIcon className={`tooltip-type-icon ${types.includes("Web") ? "web-icon-active" : ""}`} />
                <ApplicationIcon className={`tooltip-type-icon ${types.includes("Application") ? "application-icon-active" : ""}`} />
                <DesignIcon className={`tooltip-type-icon ${types.includes("Design") ? "design-icon-active" : ""}`} />
            </div>
        )
    }

    const TooltipAuthors = ({ authors }) => {

        const stringToAvatarUrl = (name) => {
            if (authorDict[name])
                return authorDict[name];
            else
                return undefined;
        }

        const stringToAvatarString = (name) => {
            if (authorDict[name])
                return undefined;
            else {
                const splitedName = name.split(' ');
                if (splitedName.length > 1) {
                    return `${name.split(' ')[0]}${name.split(' ')[1]}`;
                }
                else {
                    return name.substring(0, 2);
                }
            }
        }

        return (
            <div className="project-card-tooltip-authors">
                <Grid container spacing={1} direction="row">
                    {
                        authors.map(author => {

                            const predefined = stringToAvatarUrl(author);

                            return (
                                <Grid item xs={2}>
                                    <Link href={predefined?.link ?? undefined} target="_blank">
                                        <Tooltip title={author} placement="bottom" arrow classes={{ tooltip: "tooltip-author" }}>
                                            <Avatar variant="rounded" src={predefined?.icon}>
                                                {stringToAvatarString(author)}
                                            </Avatar>
                                        </Tooltip>
                                    </Link>
                                </Grid >
                            )
                        })
                    }
                </Grid>
            </div>
        )
    }

    const TooltipExp = ({ exp }) => {

        const [expGroup, setExpGroup] = useState();

        useEffect(() => {
            setExpGroup(groupTypes());
        }, [])

        const groupTypes = () => {
            const config = Object.entries(typeClassificationConfig);

            return exp?.reduce((buffer, [expType, expAmount]) => {
                const archetype = config.find(([typeName, typeConfig]) => typeConfig.subtypes?.includes(expType))[0];
                if (archetype) {
                    if (!buffer[archetype])
                        buffer[archetype] = [[expType, expAmount]];
                    else
                        buffer[archetype].push([expType, expAmount]);
                }

                return buffer;
            }, {});
        }

        return (
            <div className="project-card-tooltip-exp">
                {
                    expGroup &&
                    Object.entries(expGroup).map(([archetype, subtypes]) => {
                        const TargetIcon = typeClassificationConfig[archetype].icon;

                        return (
                            <div className="project-card-tooltip-exp-entry">
                                <div className="project-card-tooltip-exp-entry-inline">
                                    <span style={{ marginRight: 5 }}>+{subtypes.reduce((acc, [expType, expValue]) => acc += expValue, 0)} </span>
                                    <span style={{ marginRight: 2 }}>{archetype}</span>
                                    <span style={{ marginRight: 5 }}><TargetIcon className={`project-card-tooltip-inline-icon ${archetype.replace(" ", "-").toLowerCase()}-icon-active`} /></span>
                                    <span style={{ marginRight: 5 }}> XP: </span>
                                </div>

                                <div className="project-card-tooltip-exp-entry-indent">
                                    {
                                        subtypes.map(([expType, expAmount]) =>
                                            <div className="project-card-tooltip-exp-entry-inline">
                                                <span style={{ marginRight: 5 }}>+{expAmount} </span>
                                                <span style={{ marginRight: 5 }}><TargetIcon className={`project-card-tooltip-inline-icon ${archetype.replace(" ", "-").toLowerCase()}-icon-active`} /></span>
                                                <span style={{ marginRight: 5 }}> XP </span>
                                                <span>from {expType}</span>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    return (
        <Tooltip title={<ProjectCardTooltipContentWrapper />} placement={isMobile ? "bottom" : "right-end"} interactive classes={{ tooltip: "tooltip-proper" }}>
            {children}
        </Tooltip>
    )

}